import { REDUX_ACTIONS } from '../../shared/config/constants';

const initialState = {
  loading: false,
  deleting: false,
  data: [],
  errorMessage: '',
  loadingDelete: false,
  paginatedElements: 0,
  limit: 100,
  currentPage: 1,
  totalCount: 0,
  searchKey: null,
  startDate: null,
  endDate: null,
  filters: [],
  sort: null,
};

const userBugsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.USER_BUGS_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: '',
      };
    case REDUX_ACTIONS.USER_BUGS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.data],
        paginatedElements: action.payload.paginatedElements,
        totalCount: action.payload.totalCount,
        errorMessage: '',
      };
    case REDUX_ACTIONS.USER_BUGS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: [],
      };
    case REDUX_ACTIONS.USER_BUGS_SEARCH_CONTROL:
      return {
        ...state,
        searchKey: action.payload.searchKey,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate
      };
    case REDUX_ACTIONS.USER_BUGS_SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };
    case REDUX_ACTIONS.USER_BUGS_SET_FILTER:
      return {
        ...state,
        filters: action.payload
      };
    case REDUX_ACTIONS.USER_BUGS_SET_SORT:
      return {
        ...state,
        sort: action.payload
      };
    default:
      return state;
  }
};

export default userBugsReducer;
